export const FETCH_CONTACT_METHOD_REQUEST = "FETCH_CONTACT_METHOD_REQUEST";
export const UPDATE_CONTACT_METHOD_REQUEST = "UPDATE_CONTACT_METHOD_REQUEST";
